<script>
  import { assignTrendFills } from '../utils/assign-trend-fills.js';

  export let fillClass;
  export let borderClass;
  export let holdoversClass;
  export let netChanges;

  const centerX = 359.34;
  const seatSize = 18.32;
  const seatStep = 20.97;

  const rows = [
    0.57,
    21.54,
    42.51,
    63.47,
    84.44,
    105.36,
    126.33,
    147.3,
    168.27,
    189.24,
    210.21,
    231.18,
    252.15,
    273.12,
    294.09,
    315.06,
    336.03,
    356.99,
    377.96,
  ];

  // [x, first seat number, starting row, seat count]
  const columns = [
    [23.89, 1, 9, 10],
    [44.86, 11, 8, 11],
    [65.82, 22, 7, 12],
    [86.79, 34, 6, 13],
    [107.76, 47, 5, 14],
    [128.73, 61, 4, 15],
    [149.7, 76, 3, 16],
    [170.67, 92, 3, 16],
    [191.64, 108, 2, 17],
    [212.61, 125, 1, 16],
    [233.58, 141, 1, 14],
    [254.55, 155, 1, 13],
    [275.52, 168, 0, 13],
    [296.49, 181, 0, 13],
    [317.41, 194, 0, 12],
    [338.38, 206, 0, 12],

    // Move seat 218 to the top row.
    [350.18, 218, 0, 1],

    [361.97, 219, 0, 12],
    [382.94, 231, 0, 12],
    [403.86, 243, 0, 13],
    [424.83, 256, 0, 13],
    [445.8, 269, 1, 13],
    [466.77, 282, 1, 14],
    [487.74, 296, 1, 16],
    [508.71, 312, 2, 17],
    [529.68, 329, 3, 16],
    [550.65, 345, 3, 16],
    [571.62, 361, 4, 15],
    [592.59, 376, 5, 14],
    [613.56, 390, 6, 13],
    [634.52, 403, 7, 12],
    [655.49, 415, 8, 11],
    [676.46, 426, 9, 10],
  ];

  // Nine seats in the top row, ordered from left to right.
  const topRowSeatNumbers = [
    168,
    181,
    194,
    206,
    218,
    219,
    231,
    243,
    256,
  ];

  const topRowPositions = new Map(
    topRowSeatNumbers.map((n, i) => [
      n,
      centerX -
        seatSize / 2 +
        (i - Math.floor(topRowSeatNumbers.length / 2)) * seatStep,
    ])
  );

  const seats = columns.flatMap(
    ([x, first, start, count]) =>
      Array.from({ length: count }, (_, i) => {
        const n = first + i;
        const y = rows[start + i];

        return {
          n,
          isCenter: n === 218,
          x: y === rows[0] ? topRowPositions.get(n) ?? x : x,
          y,
        };
      })
  );

  $: seatLayout = assignTrendFills(
    seats,
    fillClass,
    holdoversClass,
    borderClass,
    netChanges,
    centerX,
    seatSize
  );

  $: seatFills = seatLayout.fills;
  $: seatBorders = seatLayout.borders;
</script>

<div class="seat-chart seat-chart--house">
  <svg
    id="house-svg"
    class="seat-chart__svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="23.89 0 670.89 396.78"
    aria-hidden="true"
  >
    <g id="house-seats">
      <!-- Draw first so the line stays behind the squares. -->
      <line
        id="house-half-line"
        class="seat-chart__half-line"
        x1={centerX}
        y1={rows[0]}
        x2={centerX}
        y2="280.97"
      />

      {#each seats as seat (seat.n)}
        <rect
          id={`house-seat-${seat.n}`}
          data-name={seat.n}
          class="seat-chart__house-seat {seatFills.get(seat.n)} {seatBorders.get(seat.n)} {holdoversClass(seat.n)}"
          x={seat.x + 1}
          y={seat.y + 1}
          width="16.32"
          height="16.32"
        />
      {/each}
    </g>
  </svg>

  <div class="seat-chart__majority text-sm">
    <span>218 seats</span>
    <span>for a majority</span>
  </div>
</div>

<style>
  .seat-chart--house .seat-chart__majority {
    top: 73.45%;
  }
</style>